var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPainelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "square-poll-horizontal-solid",
    clipPath: "url(#clip0_42_2632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.5 5.25C24.5 3.31953 22.9305 1.75 21 1.75H3.5C1.56953 1.75 0 3.31953 0 5.25V22.75C0 24.6805 1.56953 26.25 3.5 26.25H21C22.9305 26.25 24.5 24.6805 24.5 22.75V5.25ZM14 8.75C14 9.71797 13.218 10.5 12.25 10.5H7C6.03203 10.5 5.25 9.71797 5.25 8.75C5.25 7.78203 6.03203 7 7 7H12.25C13.218 7 14 7.78203 14 8.75ZM17.5 12.25C18.468 12.25 19.25 13.032 19.25 14C19.25 14.968 18.468 15.75 17.5 15.75H7C6.03203 15.75 5.25 14.968 5.25 14C5.25 13.032 6.03203 12.25 7 12.25H17.5ZM10.5 19.25C10.5 20.218 9.71797 21 8.75 21H7C6.03203 21 5.25 20.218 5.25 19.25C5.25 18.282 6.03203 17.5 7 17.5H8.75C9.71797 17.5 10.5 18.282 10.5 19.25Z",
    fill: "#1D4F5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_2632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.5,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainelIcon);
export default __webpack_public_path__ + "static/media/painel_icon.b218ef649df50d2ce82bbd44a6639321.svg";
export { ForwardRef as ReactComponent };